import { useTranslation } from 'react-i18next';

export const createRoute = 'ROUTE_MONITORING.MAP_MULTI_SELECT.CREATE_ROUTE';
export const multiSelectSendToPlanning = 'ROUTE_MONITORING.MAP_MULTI_SELECT.SEND_TO_PLANNING';
export const cancelOrder = 'ROUTE_MONITORING.MAP_MULTI_SELECT.CANCEL_ORDERS';
export const unassignOrders = 'ROUTE_MONITORING.MAP_MULTI_SELECT.UNASSIGN_ORDERS';
export const addToRoute = 'ROUTE_MONITORING.MAP_MULTI_SELECT.ADD_TO_ROUTE';
export const multiSelectOrders = 'ROUTE_MONITORING.MAP_MULTI_SELECT.ORDERS';
export const moreThenTeamError = 'ROUTE_MONITORING.MAP_MULTI_SELECT.ONE_TEAM_ERROR';
export const notSameExecuteError = 'ROUTE_MONITORING.MAP_MULTI_SELECT.SAME_EXECUTE_STATUS_ERROR';

export const sendToPlanning = 'MONITORING.ACTIONS.SEND_TO_PLANNING.TITLE';
export const sendToPlanningSuccess = 'MONITORING.ACTIONS.SEND_TO_PLANNING.SUCCESS_MESSAGE';
export const sendToPlanningFail = 'MONITORING.ACTIONS.SEND_TO_PLANNING.FAIL_MESSAGE';
export const sendToDispatch = 'MONITORING.ACTIONS.SEND_TO_DISPATCH.TITLE';
export const assignDriver = 'MONITORING.ACTIONS.ASSIGN_DRIVER.TITLE';
export const reassignDriver = 'MONITORING.ACTIONS.REASSIGN_DRIVER.TITLE';
export const assignVehicle = 'MONITORING.ACTIONS.ASSIGN_VEHICLE.TITLE';
export const reassignVehicle = 'MONITORING.ACTIONS.REASSIGN_VEHICLE.TITLE';
export const sendToDispatchSuccess = 'MONITORING.ACTIONS.SEND_TO_DISPATCH.SUCCESS_MESSAGE';
export const sendToDispatchFail = 'MONITORING.ACTIONS.SEND_TO_DISPATCH.FAIL_MESSAGE';

export const donePlanning = 'MONITORING.ACTIONS.DONE_PLANNING.TITLE';
export const donePlanningSuccess = 'MONITORING.ACTIONS.DONE_PLANNING.SUCCESS_MESSAGE';
export const donePlanningFail = 'MONITORING.ACTIONS.DONE_PLANNING.FAIL_MESSAGE';
export const noTeam = 'MONITORING.TEAM_FILTER.OPTIONS.NO_TEAM.TITLE';
export const noTeamInfo = 'MONITORING.TEAM_FILTER.OPTIONS.NO_TEAM.INFO';
export const teamLimitInfo = 'MONITORING.TEAM_FILTER.LIMIT_SELECTION_INFO';
export const selectAllTeams = 'MONITORING.TEAM_FILTER.SELECT_ALL_TEAMS';

export const RoutesPlanner = 'ROUTE_MONITORING.ROUTES_PLANNER';
export const bulkActions = 'ROUTE_MONITORING.BULK_ACTIONS';

export const onlyTasksWithTeamsError = 'PLANNING.ONLY_TASKS_WITH_TEAM';
export const onlyOneTeamError = 'PLANNING.ONLY_ONE_TEAM';
export const taskWithoutDropOffWayPointError = 'PLANNING.TASK_WITHOUT_DROP_OFF_WAY_POINT';
export const sameExecuteStatusError = 'ROUTE_MONITORING.MAP_MULTI_SELECT.SAME_EXECUTE_STATUS_ERROR';
export const noRouteSelectedError = 'PLANNING.NO_ROUTE_SELECTED';
export const onlyTasksWithRunError = 'PLANNING.ONLY_TASKS_WITH_RUN';
export const sameDateError = 'PLANNING.ONLY_SAME_DATE';

export const openPreviewDescription = 'RUN_PARTIAL_ACTIONS.OPEN_PREVIEW_DESCRIPTION';

export const groupBy = 'ORDER_DETAILS.GROUPING.GROUP_BY';
export const noGrouping = 'ORDER_DETAILS.GROUPING.NO_GROUPING';
export const team = 'ORDER_DETAILS.GROUPING.TEAM';
export const teamAndDriver = 'ORDER_DETAILS.GROUPING.TEAM_AND_DRIVER';
export const route = 'ORDER_DETAILS.GROUPING.ROUTE';
export const teamAndRoute = 'ORDER_DETAILS.GROUPING.TEAM_AND_ROUTE';
export const driverGroup = 'ORDER_DETAILS.GROUPING.DRIVER';

const useMonitoringTranslations = () => {
	const { t } = useTranslation();

	return {
		createRoute: t(createRoute),
		multiSelectSendToPlanning: t(multiSelectSendToPlanning),
		cancelOrder: t(cancelOrder),
		unassignOrders: t(unassignOrders),
		addToRoute: t(addToRoute),
		multiSelectOrders: (count: number) => t('ROUTE_MONITORING.MAP_MULTI_SELECT.ORDERS', { count }),
		moreThenTeamError: t(moreThenTeamError),
		notSameExecuteError: t(notSameExecuteError),

		donePlanning: t(donePlanning),
		donePlanningSuccess: t(donePlanningSuccess),
		donePlanningFail: t(donePlanningFail),
		sendToPlanning: t(sendToPlanning),
		sendToPlanningSuccess: t(sendToPlanningSuccess),
		sendToPlanningFail: t(sendToPlanningFail),
		sendToDispatch: t(sendToDispatch),
		sendToDispatchSuccess: t(sendToDispatchSuccess),
		sendToDispatchFail: t(sendToDispatchFail),
		assignDriver: t(assignDriver),
		reassignDriver: t(reassignDriver),
		assignVehicle: t(assignVehicle),
		reassignVehicle: t(reassignVehicle),
		routesPlanner: t(RoutesPlanner),
		bulkActions: t(bulkActions),
		onlyTasksWithTeamsError: t(onlyTasksWithTeamsError),
		onlyOneTeamError: t(onlyOneTeamError),
		taskWithoutDropOffWayPointError: t(taskWithoutDropOffWayPointError),
		sameExecuteStatusError: t(sameExecuteStatusError),
		noRouteSelectedError: t(noRouteSelectedError),
		onlyTasksWithRunError: t(onlyTasksWithRunError),
		sameDateError: t(sameDateError),
		openPreviewDescription: t(openPreviewDescription),
		noTeam: t(noTeam),
		noTeamInfo: t(noTeamInfo),
		teamLimitInfo: t(teamLimitInfo),
		selectAllTeams: t(selectAllTeams),
		groupBy: {
			groupBy: t(groupBy),
			noGrouping: t(noGrouping),
			driver: t(driverGroup),
			team: t(team),
			teamAndDriver: t(teamAndDriver),
			route: t(route),
			teamAndRoute: t(teamAndRoute)
		}
	};
};

export default useMonitoringTranslations;
